import React from 'react'
import { userService } from '@cabukaka/services';
import { User } from '@cabukaka/types';
import useDataById from '../core/useDataById';

export default function useUser({ id }: { id: string }) {
    const {
        data: user,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<User>({ service: {
        ...userService,
        ...userService.baseService
    }, id });

    const verifyUser = async ()=>{
      try {
        updateItem({isVerified: true , id})
      } catch (error) {
        throw error
      }
    }


    return {
     user,
     error,
     loading,
     deleteUser: deleteItem,
     updateUser: updateItem,
     verifyUser
    }

}
